import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Row } from "reactstrap";
import { changeStepper } from "../../../shared/helpers/changeStepper";
import { IStepper } from "../../../shared/model/IStepper";

interface IProps {
  stepper: IStepper;
  setStepper: (data: IStepper) => void;
  formik: any;
  getAdditionalQuestion: (current: number) => void;
  handleClose: () => void;
  setErrorIncompleteFields: (data: boolean) => void;
  setShowErrorsInputs: (data: boolean) => void;
  validate: () => void;
}

export const ButtonsGroup = (props: IProps) => {
  const { formik, getAdditionalQuestion, handleClose } = props;

  const handleAdditionalQuestion = (number: number) => {
    if (formik.isValid) {
      props.setShowErrorsInputs(false);
      getAdditionalQuestion(number);
    } else {
      props.setErrorIncompleteFields(true);
      props.setShowErrorsInputs(true);
    }
  };
  return (
    <Row>
      <Col className="col-buttons-group">
        {props.stepper.current === props.stepper.firstStep && (
          <Button
            className="btn-previous"
            name="previous"
            onClick={handleClose}
          >
            Cancelar
          </Button>
        )}
        {props.stepper.current !== props.stepper.firstStep && (
          <Button
            className="btn-previous"
            name="previous"
            onClick={(e: any) =>
              changeStepper(e, props.stepper.previous, props)
            }
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            Anterior
          </Button>
        )}
        {props.stepper.current !== props.stepper.lastStep && (
          <Button
            className="btn-next"
            name="next"
            onClick={(e: any) => changeStepper(e, props.stepper.next, props)}
            disabled={!formik.dirty && !formik.values?.id}
          >
            Siguiente
            <FontAwesomeIcon icon={faArrowRight} />
          </Button>
        )}
        {props.stepper.current === props.stepper.lastStep && (
          <Button
            className="btn-next"
            name="next"
            disabled={!formik.dirty && !formik.values?.id}
            onClick={() => handleAdditionalQuestion(0)}
          >
            Postularme
            <FontAwesomeIcon icon={faArrowRight} />
          </Button>
        )}
      </Col>
    </Row>
  );
};
